import React from "react";
import Button from "@mui/material/Button";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ButtonGroup from "../Buttons/ButtonGroup";

const useStyles = makeStyles(theme => ({
  iconSizeMedium: {
    "& > *:first-child": {
      fontSize: "1.5rem"
    }
  },
  arrowLeft: {
    transform: "rotate(180deg)"
  }
}));
const ContentViewerNavigationButtons = ({
  handleNextActivity,
  handlePrevActivity,
  lastActivity,
  shortCourseCompleted,
  previousLink,
  onExitShortCourse,
  disabled
}) => {
  const { arrowLeft, iconSizeMedium } = useStyles();
  const { t } = useTranslation();
  function getExitShortCourseButton() {
    if (lastActivity || shortCourseCompleted) {
      return (
        <>
          <Button
            color="primary"
            variant="outlined"
            classes={{ iconSizeMedium }}
            onClick={() => onExitShortCourse()}
            endIcon={<ExitToAppIcon fontSize="large" />}
            disabled={disabled}
            data-qa="exit-short-course-btn"
          >
            {t("contentViewer.navigationButtons.exit")}
          </Button>
        </>
      );
    }
    return null;
  }

  function getNextActivityButton() {
    if (lastActivity) {
      return null;
    }
    return (
      <Button
        color="primary"
        variant="outlined"
        classes={{ iconSizeMedium }}
        onClick={() => handleNextActivity()}
        disabled={disabled}
        data-qa="next-activity-btn"
      >
        {t("contentViewer.navigationButtons.nextActivity")}
        <ArrowRightAltIcon />
      </Button>
    );
  }

  function getPrevActivityButton() {
    if (previousLink) {
      return (
        <Button
          color="primary"
          variant="outlined"
          classes={{ iconSizeMedium }}
          onClick={() => handlePrevActivity()}
          startIcon={
            <ArrowRightAltIcon className={arrowLeft} fontSize="large" />
          }
          disabled={disabled}
          data-qa="previous-activity-btn"
        >
          {t("contentViewer.navigationButtons.prevActivity")}
        </Button>
      );
    }
    return null;
  }

  return (
    <div>
      <ButtonGroup>
        {getPrevActivityButton()}
        {getNextActivityButton()}
        {getExitShortCourseButton()}
      </ButtonGroup>
    </div>
  );
};

export default ContentViewerNavigationButtons;

ContentViewerNavigationButtons.propTypes = {
  previousLink: PropTypes.string,
  lastActivity: PropTypes.bool,
  shortCourseCompleted: PropTypes.bool,
  showModal: PropTypes.func,
  handleNextActivity: PropTypes.func,
  handlePrevActivity: PropTypes.func
};
